/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: geetestMixin
 * @Date: 2020/4/17
 * @Author: liux
 * @Copyright（C）2020 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */

import {api} from '../utils'
import {getSlient} from 'bjxy-common/network/http'
import initGeetest from 'bjxy-common/helper/gt'

const isDevProxy = process.env.VUE_APP_PROXY === 'proxy'


export default function getGeetest(){
  return new Promise( (resolve,reject)=> {
    getSlient(isDevProxy ? '/zhifu/geetest?t='+ Date.now() : api.GEETEST+ Date.now()).then(json=>{
      if(json.status === 1){
        var geetestInfo = json.data
        var params = {
          gt: geetestInfo.gt,
          challenge: geetestInfo.challenge,
          offline: !geetestInfo.success,
          new_captcha: geetestInfo.new_captcha,
          timeout: '5000',
          product: 'bind',
          width: '15rem'
        }
        initGeetest(params,  (captchaObj)=> {
          // 这里可以调用验证实例 captchaObj 的实例方法
          captchaObj.onReady(()=>{
            //验证码ready之后才能调用verify方法显示验证码
            captchaObj.verify()
          }).onSuccess(()=>{
            //用户验证成功
            var result = captchaObj.getValidate();
            if(result){
              resolve({...result,id:geetestInfo.id})
            }else {
              reject('请完成认证')
            }
          }).onError(()=>{
            //刷新过多、静态资源加载失败、网络不给力等
            reject('极验失败，稍后重试')
          })
        })
      }else{
        reject(json.msg)
      }
    })
  })
}
